<script>
  import { onMount, onDestroy } from "svelte";
  import Tailwind from "./components/Tailwind.svelte";
  import Header from "./components/Header.svelte";
  import QuickstartNav from "./components/QuickstartNav.svelte";
  import Workout from "./components/Workout.svelte";
  import WorkoutRFT from "./components/WorkoutRFT.svelte";
  import Menu from "./components/Menu.svelte";
  import Toast from "./components/Toast.svelte";
  import Install from "./components/Install.svelte";
  import GoogleAnalytics from "./components/GoogleAnalytics.svelte";
  let isWorkoutStarted = false;
  let setup;
  let pause = false;
  let done = false;
  let GA_ID = "G-4FDXLPVTGS";

  let url;

  onMount(() => (url = window.location.href));

  const urlParams = new URLSearchParams(window.location.search);
  history.replaceState("data to be passed", "Title of the page", "/");

  function startWorkout(event) {
    isWorkoutStarted = true;
    setup = event.detail;
  }

  function finish(event) {
    isWorkoutStarted = false;
    pause = false;
    done = false;
  }
</script>

<GoogleAnalytics id={GA_ID} />
<Install />
<div
  class="bg-hero h-screen bg-no-repeat bg-center bg-cover bg-blend-overlay fixed w-full right-0 top-0"
/>

<main class="relative h-full right-0 top-0">
  <Menu bind:isWorkoutStarted bind:pause bind:done on:finish={finish} />
  <div class="absolute text-white w-full">
    <div
      class="flex flex-col"
      class:min-h-screen={!isWorkoutStarted}
      class:h-screen={isWorkoutStarted}
    >
      <Header />
      <div
        class="flex sm:justify-center items-center flex-col flex-1 sm:flex-row"
      >
        {#if isWorkoutStarted}
          {#if setup.type === "rft"}
            <WorkoutRFT {setup} bind:pause bind:done />
          {:else}
            <Workout {setup} bind:pause bind:done />
          {/if}
        {:else}
          <QuickstartNav on:startWorkout={startWorkout} {urlParams} />
        {/if}
      </div>
    </div>
    <footer
      class="bg-gray-900 bg-opacity-90 p-2 flex flex-row items-center justify-center"
    >
      <p class="text-xs mr-2">Developed with love to Sport.</p>
      <a
        href="https://twitter.com/CrossFitTimers"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-block text-white hover:scale-105 transform transition duration-200 ease-in-out"
      >
        <svg
          class="w-8 h-8 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 504.4 504.4"
        >
          <path
            d="M377.6.2H126.4C56.8.2 0 57 0 126.6v251.6c0 69.2 56.8 126 126.4 126H378c69.6 0 126.4-56.8 126.4-126.4V126.6C504 57 447.2.2 377.6.2zm-.4 188.8v8.4c0 84-64.8 180.8-183.6 180.8-36.4 0-70.4-10.4-98.8-28.4 5.2.4 10 .8 15.2.8 30.4 0 58-10 80-27.2-28.4-.4-52-18.8-60.4-44 4 .8 8 1.2 12 1.2 6 0 12-.8 17.2-2.4-28.8-6-50.8-31.6-50.8-62.4v-.8c8 4.8 18.4 7.6 28.8 8-17.2-11.2-28.8-30.8-28.8-52.8 0-11.6 3.2-22.4 8.8-32 32 38.4 79.2 63.6 132.8 66.4a58.9 58.9 0 0 1-1.6-14.4c0-35.2 28.8-63.6 64.4-63.6 18.4 0 35.2 7.6 47.2 20 14.8-2.8 28.4-8 40.8-15.6-4.8 14.8-15.2 27.2-28.4 35.2 13.2-1.6 25.6-4.8 37.2-10-8.8 12.8-19.6 24-32 32.8z"
          />
        </svg>
      </a>
    </footer>
  </div>
</main>

<Toast />
